module.exports = __webpack_public_path__ + "img/default.1cbd02a8.png";